module.exports = __webpack_public_path__ + "static/media/15.d7cb699f.png";